import { makeResponses } from '../response_factory';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { GlobalPermMap } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function permission(config) {
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(GlobalPermMap)),
    });
    return Object.freeze({
        /**
         * Get all the global permissions or all course permissions for all courses for the currently logged in user.
         *
         * @returns A mapping between global permission names and a boolean indicating if the currently logged in user has this permissions is returned.
         */
        getAll: async () => {
            const result = await requestParams(config, 'GET', `/api/v1/permissions/`, getAllResponse.v, undefined);
            return result;
        },
    });
}
